<template>
  <div class="training_table">
    <div class="waitingcom_title">
      <el-form
        label-width="100px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="评分表名称：" prop="operationName">
          <el-input
            v-model.trim="formLabelAlign.operationName"
            placeholder="请输入评分表名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建人：" prop="operationModel">
          <el-input
            v-model.trim="formLabelAlign.operationModel"
            placeholder="请输入创建人"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="examTime">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchData()"
          :loading="sundflag"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click.prevent.stop="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <div class="oper_box">
      <el-button @click="fun1('0')">
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        新增评分表
      </el-button>
      <el-button
        id="addButtonJm"
        @click="$refs.delete.dialogVisibleObj.importTable = true"
      >
        <img src="@/assets/button_imgs/xiazai.png" alt="" />
        导入评分表
      </el-button>
      <el-button id="addButtonJm" @click="deleteClick(0)">
        <img src="@/assets/button_imgs/shangchuang.png" alt="" />
        批量删除
      </el-button>
    </div>
    <Table
      ref="table"
      :tableObj="tableObj"
      @row="getRow"
      :fun1="fun1"
      :fun2="fun2"
      :fun3="fun3"
      :fun4="fun4"
      :fun5="fun5"
      :disabledFun="disabledFun"
      :getDatalist="getDatalist"
      :buttonShowClick="buttonShowClick"
      :pageIndexs="pageIndexs"
      :eachPageNums="eachPageNums"
    />
    <div class="foot_box">
      <div class="foot_pagetions">
        <p></p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndexs"
          :page-size="eachPageNums"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <Delete
      ref="delete"
      :statePopupstatus="statePopupstatus"
      :deleteType="deleteType"
      :userName="userName"
      :deleteNum="deleteNum"
      :deleteDetermine="deleteDetermine"
      :renameClick="renameClick"
      :getDatalist="getDatalist"
    />
  </div>
</template>

<script>
import Table from "@/components/progress/Table.vue";
import { scoreTabel } from "@/state/operation";
import { hybrid } from "@/mixin/mixin";
import assessApi from "@/api/assessment";
import Delete from "@/components/progress/Delete.vue";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      labelPosition: "right",
      sundflag: false, // 防抖
      formLabelAlign: {
        operationName: "", // 操作名称
        operationModel: "", // 操作状态
        beginTime: "",
        endTime: "",
      },
      getDataCondition: {
        operationName: "", // 操作名称
        operationModel: "", // 操作状态
      },
      examTime: "", // 时间
      tableObj: {
        buttonShow: false, // 是否有添加按钮
        getData: [], // 列表数据
        formColumns: [], // 表头
        qrShow: false, // 是否需要二维码
        // qrLabel: "操作名称", // table二维码label
        // qrorop: "name",
        loading: true,
        tooltipShow: false,
        columnWidth: "400", // 操作按钮宽度
        buttonArr: [
          {
            name: "编辑评分表",
          },
          {
            name: "导出评分表",
          },
          {
            name: "重命名",
          },
          {
            name: "复制",
          },
          {
            name: "删除",
          },
        ],
      },
      statePopupstatus: {},
      deleteType: 0, // 删除状态
      userName: "", // 单个删除的名字
      deleteNum: "", // 批量删除的个数
      pageIndexs: 1, // 起始页
      eachPageNums: 10, // mixin定义的获取渲染分页序号有误
    };
  },
  mixins: [hybrid], // 引入共用方法
  methods: {
    // 搜索
    searchData() {
      if (this.formLabelAlign.operationName) {
        this.getDataCondition.operationName = this.formLabelAlign.operationName;
      } else {
        this.getDataCondition.operationName = "";
      }
      if (this.formLabelAlign.operationModel) {
        this.getDataCondition.operationModel =
          this.formLabelAlign.operationModel;
      } else {
        this.getDataCondition.operationModel = "";
      }
      this.pageIndexs = 1;
      this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // chang查询
    searchChang() {
      this.pageIndexs = 1;
      this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 重置
    resetForm() {
      this.examTime = "";
      this.pageIndexs = 1;
      this.resetFun(this.formLabelAlign, this.getDataCondition);
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 获取当前行
    getRow(row) {
      this.rowObj = row;
    },
    // 编辑评分管理
    fun1(type) {
      this.$router.push({
        path: "/scoreTable/addTable", //跳转的路径
        query: {
          type: type == 0 ? 0 : 1,
          ID: type == 0 ? "" : this.rowObj.row.ID,
        },
      });
      if (type == undefined) {
        this.$storage.sessionSet("rowObj", this.rowObj.row, true); // 回传编辑信息
      }
    },
    // 导出评分表
    fun2() {
      this.$confirm(
        `此操作将导出${this.rowObj.row.Title}评分表, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          let obj = {
            scoreID: this.rowObj.row.ID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            hid: JSON.parse(loginvuex.state.userlist).hid,
          };
          const { data } = await assessApi.downLevel(obj);
          if (data.Status == 200) {
            // let str = data.Data.substr(30);
            // let str = data.Data.match(/(?=exam_export)(.*)/)[0]
            const link = document.createElement("a");
            // let url = `${process.env.VUE_APP_EXPORTURL}/${str}`;
            let url = data.Data;
            link.setAttribute("target", "_blank");
            link.href = url;
            link.click();
            this.$message({
              message: `恭喜你，导出${this.rowObj.row.Title}评分表成功`,
              type: "success",
            });
          } else {
            this.$message.error(data.Msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
    // 重命名
    fun3() {
      this.statePopupstatus = this.rowObj.row;
      this.$refs.delete.titleName = this.rowObj.row.Title;
      this.$refs.delete.dialogVisibleObj.modifyL = true; // 唤起弹窗
    },
    // 重命名弹窗确定
    async renameClick() {
      if (this.titleName == "") {
        this.$message({
          message: "警告，当前名称不能为空",
          type: "warning",
        });
      } else {
        let obj = {
          title: this.$refs.delete.titleName,
          contentTxt: this.statePopupstatus.ContentTxt,
          passScore: this.statePopupstatus.PassScore,
          totalScore: this.statePopupstatus.TotalScore,
          scoreID: this.statePopupstatus.ID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.userlist).hid,
        };
        this.$refs.delete.sundflag = true;
        const { data } = await assessApi.editScore(obj);
        if (data.Status == 200) {
          this.$message({
            message: "恭喜你，编辑评分表名称成功!",
            type: "success",
          });
          setTimeout(() => {
            this.$refs.delete.sundflag = false;
          }, 500);
          this.getDatalist();
        } else {
          this.$refs.delete.sundflag = false;
          this.$message.error(data.Msg);
        }
      }
      this.$refs.delete.dialogVisibleObj.modifyL = false; // 关闭弹窗
    },
    // 复制
    async fun4() {
      let obj = {
        scoreID: this.rowObj.row.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.copyScore(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，复制${this.rowObj.row.Title}成功!`,
          type: "success",
        });
        this.getDatalist();
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 删除
    fun5() {
      this.deleteClick(1, this.rowObj);
    },
    buttonShowClick(row, item) {
      return true;
    },
    // 列表获取
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.beginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.endTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.sundflag = true;
      let parameter = {
        title: this.getDataCondition.operationName, // 名称
        operateUser: this.getDataCondition.operationModel, // 创建人
        beginTime: this.formLabelAlign.beginTime, // 开始时间
        endTime: this.formLabelAlign.endTime, // 结束时间
        pageIndex: this.pageIndexs, //当前页
        pageSize: this.eachPageNums, // 一页多少条
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.getScorelist(parameter);
      if (data.Status == 200) {
        this.tableObj.getData = data.Data.list.map((item) => {
          this.$set(
            item,
            "CreateTime1",
            this.$moment(item.CreateTime).format("YYYY-MM-DD HH:mm:ss")
          );
          return item;
        });
        this.total = data.Data.dataCount;
        setTimeout(() => {
          this.tableObj.loading = false;
          this.sundflag = false;
        }, 500);
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    to() {
      this.$router.push({
        path: "/scoreTable/addTable", //跳转的路径
      });
    },
    // 是否禁用
    disabledFun(row, item) {
      return false;
    },
    // 删除
    deleteClick(type, row, index) {
      this.deleteType = type;
      if (this.$refs.table.multipleSelection.length == 0 && type == 0) {
        // 未勾选批量考生
        this.deleteType = "null";
      } else if (type == 1) {
        // 单个删除
        this.statePopupstatus = row.row;
        this.userName = this.statePopupstatus.Title;
      } else if (type == 0) {
        // 批量删除
        this.deleteNum = this.$refs.table.multipleSelectionIds.length;
      }
      this.$refs.delete.dialogVisibleObj.Delete = true;
    },
    // 删除确定
    async deleteDetermine() {
      let obj = {
        scoreIDArray: "",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.$refs.delete.sundflag = true;
      if (this.deleteType == "null") {
        // 未选择
        this.$refs.delete.sundflag = false;
        this.$refs.delete.dialogVisibleObj.Delete = false;
        return;
      }
      if (this.deleteType == 1) {
        let arr = [];
        arr.push(this.statePopupstatus.ID);
        obj.scoreIDArray = JSON.stringify(arr);
        // 单个删除
      } else if (this.deleteType == 0) {
        // 批量删除
        obj.scoreIDArray = JSON.stringify(
          this.$refs.table.multipleSelectionIds
        );
      }
      const { data } = await assessApi.deleteScore(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，删除成功!`,
          type: "success",
        });
        this.$refs.table.multipleSelectionIds = [];
        setTimeout(() => {
          this.$refs.delete.sundflag = false;
        }, 500);
        this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
        this.getDatalist();
      } else {
        this.$refs.delete.sundflag = false;
        this.$message.error(data.Msg);
      }
      this.$refs.delete.dialogVisibleObj.Delete = false;
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.loading = true;
      this.tableObj.loading = true;
      this.eachPageNums = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndexs = val;
      this.tableObj.loading = true;
      console.log(`当前页: ${this.pageIndexs}`);
      // this.loading = true;
      this.getDatalist();
    },
  },
  components: {
    Table,
    Delete,
  },
  created() {
    this.tableObj.formColumns = scoreTabel; // 表头label
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
  background: #fff;
}
.waitingcom_title {
  height: 90px;
  padding: 24px 24px 16px 22px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;

  .el-form {
    display: flex;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
</style>
